import { render } from "./Graph.Disk.Usage.vue?vue&type=template&id=1d22fac2&scoped=true"
import script from "./Graph.Disk.Usage.vue?vue&type=script&lang=js"
export * from "./Graph.Disk.Usage.vue?vue&type=script&lang=js"

import "./Graph.Disk.Usage.vue?vue&type=style&index=0&id=1d22fac2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d22fac2"]])

export default __exports__